import React from 'react';
import { Amex, Discover, MasterCard, PayPal, Visa, ApplePay } from '@fff-web/fff-ui-shared/Icon';
import styles from './PaymentIcons.module.css';

const PaymentIcons = () => (
  <div className={styles.formAccountInfoTitleWrapper}>
    <h4 className={styles.formAccountInfoTitle}>Payment Info</h4>
    <div className={styles.iconsWrapper}>
      <Visa />
      <MasterCard />
      <Amex />
      <Discover />
      <PayPal />
      <ApplePay />
    </div>
  </div>
);

export default PaymentIcons;
